/**
 * What iManage's landing and About page say, from the person's status. Pure,
 * so the wording rules are pinned by tests.
 *
 * @module components/apps/imanage/IManageLanding.logic
 */
import type { IManageStatus } from "@amoreg/contracts/imanage";

import {
  DOCUMENT_STORE_OPERATION_LABELS,
  DOCUMENT_STORE_OPERATIONS,
} from "../integrations/integrationContent";

/**
 * - unavailable: the status could not be read
 * - not-configured: the organization has not set iManage up
 * - pending: a sign-in is open in another tab
 * - ready: set up, and this person can connect
 * - connected
 */
export type IManageLandingState = "unavailable" | "not-configured" | "pending" | "ready" | "connected";

export function imanageLandingState(
  status: Pick<IManageStatus, "configured" | "connected" | "pending"> | null,
): IManageLandingState {
  if (!status) return "unavailable";
  if (status.connected) return "connected";
  if (!status.configured) return "not-configured";
  return status.pending ? "pending" : "ready";
}

/**
 * The operations the organization allows, as one phrase in a stable order:
 * "search, list, read and download". Null when it allows none.
 */
export function allowedOperationsPhrase(operations: ReadonlyArray<string>): string | null {
  const labels = DOCUMENT_STORE_OPERATIONS.filter((operation) =>
    operations.includes(operation),
  ).map((operation) => DOCUMENT_STORE_OPERATION_LABELS[operation].label.toLowerCase());
  if (labels.length === 0) return null;
  if (labels.length === 1) return labels[0]!;
  return `${labels.slice(0, -1).join(", ")} and ${labels.at(-1)}`;
}
